import { render, staticRenderFns } from "./HelpCategoriesComponent.vue?vue&type=template&id=7bcbc9dc&scoped=true&"
import script from "./HelpCategoriesComponent.vue?vue&type=script&lang=js&"
export * from "./HelpCategoriesComponent.vue?vue&type=script&lang=js&"
import style0 from "./HelpCategoriesComponent.vue?vue&type=style&index=0&id=7bcbc9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcbc9dc",
  null
  
)

export default component.exports